import { useEffect, useState, useMemo } from "react";

// Componentes
import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../../componentsUI/formularios/button/BotonAction.js";
import SelectGenerico from "../../../../componentsUI/formularios/selector/selectorGenerico.js";

import { useInventarioMovimiento } from "../../../../contexto/provider/InventarioMovimientoContext.js";
import { usePeriodoInventario } from "../../../../contexto/provider/InventarioPeriodosContext.js";

import "./tabla2.css";

export default function TablaMovimientoInventario({ rowsPerPage = 8 }) {
  const {
    movimientoInventario = [],
    loading,
    listarMovimientoInventario,
  } = useInventarioMovimiento();
  const { periodos, listarPeriodos } = usePeriodoInventario();

  // estados internos
  const [periodoId, setPeriodoId] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  
  const limiteFilas = Math.min(rowsPerPage, 20);

// 1️⃣ primero filtrar
const datosFiltrados = useMemo(() => {
  if (!periodoId) return movimientoInventario;

  return movimientoInventario.filter(
    (m) => String(m.periodo_id) === String(periodoId)
  );
}, [movimientoInventario, periodoId]);

// 2️⃣ luego calcular paginas
const totalPaginas = Math.max(
  1,
  Math.ceil(datosFiltrados.length / limiteFilas)
);

// 3️⃣ luego paginar
const datosPaginados = useMemo(() => {
  const inicio = (paginaActual - 1) * limiteFilas;
  const fin = inicio + limiteFilas;
  return datosFiltrados.slice(inicio, fin);
}, [datosFiltrados, paginaActual, limiteFilas]);


  // cambiar página
  const cambiarPagina = (numero) => {
    if (numero >= 1 && numero <= totalPaginas) {
      setPaginaActual(numero);
    }
  };

  // cargar datos iniciales
  useEffect(() => {
    console.log("[TablaInventarioXMetodo] solicitando inventario");
    listarPeriodos();
    listarMovimientoInventario();
  }, [listarMovimientoInventario, listarPeriodos]);

  // resetear paginación cuando cambian datos
  useEffect(() => {
    console.log("[TablaInventarioXMetodo] datos actualizados", {
      cantidad: movimientoInventario.length,
    });
    setPaginaActual(1);
  }, [movimientoInventario]);
  if (loading) return <p>Cargando inventario...</p>;

  console.log("se selecciono el periodo:", periodoId);

  return (
    <div>
      <TituloModulo titulo="Movimientos del inventario" />

      <BotonAccion
        onClick={() => {
          console.log("recargando inventario manualmente");
          listarMovimientoInventario({ fuerza: true });
        }}
      >
        Cargar
      </BotonAccion>
      <SelectGenerico
        id="select-periodo"
        label="Seleccionar periodo"
        value={periodoId}
        onChange={setPeriodoId}
        options={periodos}
        getOptionValue={(p) => p.id}
        getOptionLabel={(p) => `${p.anio}-${p.mes}`}
      />

      <div className="tabla-container">
        <div className="tabla-scroll">
          <table className="tabla-reporte">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Producto</th>
                <th >Cant.</th>
                <th>Tipo</th>
              </tr>
            </thead>

            <tbody>
              {datosPaginados.length === 0 ? (
                <tr>
                  <td colSpan="3">Sin registros</td>
                </tr>
              ) : (
                datosPaginados.map((fila, index) => (
                  <tr
                    key={`${fila.fecha_creacion}-${fila.id_producto}-${fila.movimiento_id}`}
                  >
                    <td>{fila.fecha_creacion}</td>

                    <td>{fila.producto}</td>

                    <td className="col-3">{fila.cantidad}</td>
                    <td className="col-2">{fila.origen}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="paginacion">
          <button
            disabled={paginaActual === 1}
            onClick={() => cambiarPagina(paginaActual - 1)}
          >
            ←
          </button>

          <span>
            Página {paginaActual} de {totalPaginas}
          </span>

          <button
            disabled={paginaActual === totalPaginas}
            onClick={() => cambiarPagina(paginaActual + 1)}
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
}
